import { ISupplierResponse } from '../models/request-and-responses/rest-api/interfaces/supplierResponse';

export class Supplier implements ISupplierResponse {
    idCode: string;
    name: string;
    constructor(supp: ISupplierResponse) {
        this.idCode = supp.idCode;
        this.name = supp.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/supplier.class.ts